const formatNumber = (number, maxPrecision) => {
  return Number(Number(number).toFixed(maxPrecision))
}

export default formatNumber
